import React, { useEffect, useContext, useRef } from 'react';
import { MapContext } from '../contexts/MapProvider';
import { makeStyles } from '@material-ui/core/styles';

// import Logo from "../components/Logo";

import 'mapbox-gl/dist/mapbox-gl.css';
import '../styles/mapbox-gl-geocoder.css';

const useStyles = makeStyles(() => ({
  map: {
    position: 'absolute',
    width: '100%',
    top: 0,
    bottom: 0,
  },
}));

const Map = () => {
  const { setMap } = useContext(MapContext);

  const classes = useStyles();

  const mapRef = useRef();

  useEffect(() => {
    setMap(mapRef);
  }, [setMap, mapRef]);

  return <div ref={(el) => (mapRef.current = el)} className={classes.map} />;
};

export default Map;
